// extracted by mini-css-extract-plugin
export default {"loader":"k9oKtcQM","isFullpage":"RY6I4o7S","path1":"asaciavL","path2":"B6Za3NI7","path3":"yLqOfgrS","path4":"zDJzZxS5","fadeIn":"aVzDUxkF"};